import { values, difference } from 'lodash';
import Base from 'app/collections/base';
import { fulfillmentUrl } from 'utils/wrappers';
import FulfillmentInventory from 'app/models/fulfillment_inventory';

export default Base.extend({
  model: FulfillmentInventory,
  url: fulfillmentUrl('inventories', 'v2'),

  initialize(models, { apiModeSelection }) {
    this.apiModeSelection = apiModeSelection;
    this.inventoryCache = { test: [], production: [] };
  },

  fetch(options = {}) {
    const { mode } = this.apiModeSelection.getParams();

    // if there are no product ids, don't do anything.
    if (!options.productIds || !options.productIds.length) {
      return;
    }

    // filter out ids already loaded, so we make the smallest request possible.
    const ids = difference(
      options.productIds,
      this.inventoryCache[mode].map(inventory => inventory.product_id),
    );

    // if all of the products are already loaded into cache, reset the
    // collection from the cache.
    if (!ids.length) {
      this.reset(values(this.inventoryCache[mode]));
      this.trigger('sync');
      return;
    }

    Base.prototype.fetch.call(this, { data: { product_ids: ids, includes: ['warehouse'] } });
  },

  paramsForFetch() {
    return { ...this.apiModeSelection.getParams() };
  },

  parse(response) {
    const { mode } = this.apiModeSelection.getParams();

    // load the response into the cache by id
    this.inventoryCache[mode] = [
      ...this.inventoryCache[mode],
      ...response.inventories,
    ];

    return this.inventoryCache[mode];
  },
});



// WEBPACK FOOTER //
// ./app/collections/fulfillment_inventory.js